'use strict';

/**
 * Layout for review import
 *
 * @category   View
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var ReviewListView = require('../partials/review-list');

var template = require('../../templates/components/review.hbs');

var ReviewComponent = ColidoLayoutView.extend({
    template: template,

    ui: {
        container: '.import-component',
        linkStepBefore: '[data-action="step-before"]',
        buttonSaveImport: '.btn[data-action="save-import"]',
        linkSaveImport: 'a[data-action="save-import"]',
        duplicatesRow: '.import-review-duplicates',
    },

    events: {
        'click @ui.linkStepBefore': 'onActionStepBefore',
        'click @ui.buttonSaveImport': 'onActionSaveImport',
        'click @ui.linkSaveImport': 'onActionSaveImport',
    },

    regions: {
        reviewListRegion: '#subregion-review-list',
    },

    viewData: {
        step: function() {
            return this.getOption('step') || 3;
        },
    },

    modelEvents: {
        'change:state': 'onChangeState',
    },

    reviewListView: null,

    onRender: function() {
        this.reviewListView = new ReviewListView({
            collection: this.collection,
        });

        this.reviewListRegion.show(this.reviewListView);
    },

    /**
     * Is triggered from text, when we should go to previous step
     */
    onActionStepBefore: function() {
        this.model.set('state', 'mapping');
    },

    /**
     * Is triggered from link or button to save the import
     */
    onActionSaveImport: function() {
        this.model.set('onDuplicateKey', this.$('[name="on-duplicate-key"]:checked').val());

        this.triggerMethod('component:review:import:start');
        this.ui.buttonSaveImport.prop('disabled', true).addClass('is-loading');

        _.delay(function() {
            // Todo: Send new status to server via Importmodel
            this.triggerMethod('component:review:import:finished');
        }.bind(this), 1000);
    },

    /**
     * Is triggered, when save import is finished
     */
    onComponentReviewImportFinished: function() {
        if (!this.isDestroyed) {
            this.ui.buttonSaveImport.prop('disabled', false).removeClass('is-loading');
        }
    },

    /**
     * Is triggered from layout view, on proceed/next click
     */
    onParentProceed: function() {
        this.onActionSaveImport();
    },

    onChangeState: function() {
        if (this.model.get('state') === 'reviewing') {
            var hasObjectIdField = !!this.collection.findWhere({fieldname: 'objectId'});

            this.ui.duplicatesRow.toggle(hasObjectIdField);
        }
    },
});

module.exports = ReviewComponent;